'use strict';

require('./checkout/MaskPhoneNumber');
require('./checkout/MaskPhoneNumberBilling');

module.exports = {
  selectIso: function () {
    var phoneSelect = $(".select-phone-regex");

    if (phoneSelect.length < 1) return;

    function matchStart2(params, data) {
      params.term = params.term || '';
      if (data.text.toUpperCase().indexOf(params.term.toUpperCase()) == 0) {
          return data;
      }
      return false;
  }

    function formatState(state) {
      if (!state.id) {
        return state.text;
      }
      var $country = $(
        '<span class="flag-icon flag-icon-' +
        state.id.toLowerCase() +
        '"></span>' +
        '<span class="country-label">' + state.text + '</span>'
      );
      return $country;
    };

    phoneSelect.select2({
      templateResult: formatState,
      templateSelection: formatState,
      matcher: function(params, data) {
        return matchStart2(params, data);
    }
    }).on('select2:open', () => {
      $("body").addClass('select2-results');
      $('body').trigger('countryPhone:open');
      $('.select2-dropdown').addClass('select2Open');
    })

    $(document).on('select2:open', () => {
      setTimeout(() => document.querySelector('.select2-search__field').focus(), 200);
    });

    $(document).ready(function () {
      $(".phone-control, .shipping-phone-control,.billing-phone-control").keypress(function (event) {
         var regex = new RegExp($(this).attr('pattern'), 'g')
         if(event.which !=8 && !regex.test( String.fromCharCode(event.which))){
          event.preventDefault();
        }
       });
       $(".select-phone-regex").trigger('change');
    });

    $('.shipping-form .select-phone-regex').on('change', function (e) {
          var customerType = $('.data-checkout-stage').data('customer-type');
          var billingAddress = $('.billingAddressOne').val();
          var shippingAddress = $('.shippingAddressOne').val();
          var NumberShippingAdress = $('.shipping-phone-control').val();
          var NumberBillingAdress = $('.billing-phone-control').val();

          if (customerType === 'guest' || ((billingAddress === shippingAddress) && NumberShippingAdress ===  NumberBillingAdress)) {
              var selectedOption = $('.shipping-form .select-phone-regex').find('option:selected');
              var phoneIso = selectedOption.data('phone-iso');
              $('.billing-address .select-phone-regex option[data-phone-iso="' + phoneIso + '"]').prop('selected', true);
          }
    });

    $('.select-phone-regex').on('change', function (e) {
     e.stopPropagation();
      var self = $(this);
        var iso = self.find(':selected').data('phone-iso'),
        inputShippingPhone = $('.shipping-phone-control'),
        inpuPhoneIso = $("input[name=phoneIso]"),
        inputShippingPhoneIso = $("input[name=shippingAddressPhoneIso]");
        if (inputShippingPhone && inputShippingPhoneIso && e.target.getAttribute('data-shipping-targeted') == 'true') {
          //inputShippingPhone.attr("placeholder", placeholder);
         // inputShippingPhone.attr("pattern", pattern);
          inputShippingPhoneIso.val(iso);
        } else {
          //inputPhone.attr("placeholder", placeholder);
          //inputPhone.attr("pattern", pattern);
          inpuPhoneIso.val(iso);
        }

        $('body').trigger('refreshRegex');

        $('body').trigger('refreshRegexBilling');
    });

    function deplaceErrorMessage(){
      $('.skp-address-form .skp-error-message-phone-country').insertAfter('.skp-phone-form.skp-address-form');
    }
    deplaceErrorMessage();
  }
};
